import React from 'react';
import { RouteComponentProps } from 'react-router';
import { RequestDocumentBasePage } from './RequestDocumentBasePage';

interface Params {
  id: string;
  token: string;
}

export interface RequestDocumentPageProps extends RouteComponentProps<Params> {}

export function RequestDocumentPage(props: RequestDocumentPageProps) {
  const id = props.match.params.id ? parseInt(props.match.params.id, 10) : null;
  return (
    <RequestDocumentBasePage
      {...props}
      id={id}
      token={props.match.params.token}
    />
  );
}
